import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function LegalPageLayout({ 
  title, 
  children 
}: { 
  title: string; 
  children: React.ReactNode;
}) {
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 py-4">
          <Logo />
        </div>
      </header>
      
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <article className="prose dark:prose-invert max-w-none">
          <h1>{title}</h1>
          {children}
        </article>
      </div>
    </div>
  );
}
